import { cloneDeep, isBoolean, isObject } from 'lodash'
import utils from '../utils'
import alasql from 'alasql'

export default {
  filterData,
  filterBuilderToFilter,
}

export function filterBuilderToFilter(filterBuilder = {}) {
  const { rules = [] } = filterBuilder || {}
  const filter = rules.reduce((f, rule) => {
    const isNotEmptyValue =
      (rule.value && (!Array.isArray(rule.value) || rule.value.length > 0)) ||
      isBoolean(rule.value)
    if (rule.operator !== -1 && isNotEmptyValue) {
      f[rule.key] = {
        operator: rule.operator,
        expression: rule.expression,
        value: rule.value,
      }
    }
    return f
  }, {})
  return filter || {}
}

export function filterData(d, filter = {}, cellsMeta = {}) {
  let hasItem = false

  for (let cellKey in filter) {
    const filterItem = filter[cellKey]
    let cellType = cellsMeta[cellKey] ? cellsMeta[cellKey].type : 'string'


    if (filterItem !== null) {
      if (cellType === 'date') {
        if (filterItem.type === 'between') {
          if (!filterItem.date1 || !filterItem.date2) continue
        }
      }

      hasItem = true
      break
    }
  }

  if (hasItem) {
    const query = buildQuery(filter, cellsMeta)

    try {
    //  console.log(query)
      return alasql(query, [d])
    } catch (err) {
      console.error(err)

      return d
    }
  }

  return d
}

function buildQuery(filter, cellsMeta) {
  let query = 'SELECT * FROM ? WHERE '
  let firstCondPassed = false

  for (let cellKey in filter) {
    const partOfQuery = getPartOfQuery(filter[cellKey], cellsMeta, cellKey)

    query += firstCondPassed ? `AND ${partOfQuery}` : partOfQuery

    firstCondPassed = true
  }

  return query
}

function getPartOfQuery(filterItem, cellsMeta, cellKey) {
  const cellType = cellsMeta[cellKey] ? cellsMeta[cellKey].type : 'string'

  if (isObject(filterItem)) {
    const filterVal = filterItem.expression
      ? utils.evalExpression(filterItem.value)
      : filterItem.value

    switch (cellType) {
      case 'string':
        switch (filterItem.operator) {
          case 'contains':
            return `lower([${cellKey}]) LIKE lower("%${filterVal}%")`
          default:
            return `lower([${cellKey}]) ${filterItem.operator} lower("${filterVal}")`
        }
      case 'lookup':
        switch (filterItem.operator) {
          case 'in':
            const lookups = filterVal.map(item => `"${item.value}"`)

            return `[${cellKey}] IN (${lookups.join(',')})`
          default:
            return `[${cellKey}] ${filterItem.operator} "${filterVal.value}"`
        }
      case 'checkbox':
        return getCheckboxQuery(filterVal, cellKey)
      case 'date':
        return getDateQuery(filterVal, cellKey)
      default:
        return `lower([${cellKey}]) LIKE lower("%${filterItem}%")`
      case 'user':
        const users = filterVal.split(',').map(item => `${item}`)
        let query

        switch (filterItem.operator) {
          case '=':
            query = users.map(user => {
              return `${cellKey} LIKE "%${user}%" AND`
            })
            query = query.join(' ')
            query = query.slice(0, -4)
            break
          case '!=':
            query = users.map(user => {
              return `${cellKey} NOT LIKE "%${user}%" AND`
            })
            query = query.join(' ')
            query = query.slice(0, -4)
            break
          default:
            query = users.map(user => {
              return `${cellKey} LIKE "%${user}%" OR`
            })
            query = query.join(' ')
            query = query.slice(0, -3)
            break
        }

        return `(${query})`
    }
  }

  switch (cellType) {
    case 'lookup':
      const lookups = filterItem.split(',').map(item => `"${item}"`)

      return `[${cellKey}] IN (${lookups.join(',')})`
    case 'date':
      return getDateQuery(filterItem, cellKey)
    case 'checkbox':
      return getCheckboxQuery(filterItem, cellKey)
    case 'user':
      const users = filterItem.split(',').map(item => `${item}`)
      let query = users.map(user => {
        return `${cellKey} LIKE "%${user}%" OR`
      })
      query = query.join(' ')
      query = query.slice(0, -3)

      return `(${query})`
    default:
      return `lower([${cellKey}]) LIKE lower("%${filterItem}%")`
  }
}

function getCheckboxQuery(filterItem, cellKey) {
  return `(${cellKey} = ${filterItem} OR (${filterItem} = false AND ${cellKey} IS NULL))`
}

function getDateQuery(filterItem, cellKey) {
  //console.log(filterItem)

  if (filterItem.type === 'between') {
    const date1 = filterItem.expression
      ? utils.evalExpression(filterItem.date1)
      : filterItem.date1
    const date2 = filterItem.expression
      ? utils.evalExpression(filterItem.date2)
      : filterItem.date2

    const filterDate1 = new Date(date1)
    filterDate1.setHours(0, 0, 0, 0)
    const filterDate2 = new Date(date2)
    filterDate2.setHours(23, 59, 59, 999)

    const date1Ready = filterDate1.getTime()
    const date2Ready = filterDate2.getTime()

    return `date([$${cellKey}$Date]) BETWEEN ${date1Ready} AND ${date2Ready}`
  } else {
    const date = filterItem.expression
      ? utils.evalExpression(filterItem.date)
      : new Date(filterItem.date)

    const filterDate = new Date(date)
    filterDate.setHours(0, 0, 0, 0)

    const filterDate2 = new Date(date)
    filterDate2.setHours(23, 59, 59, 999)

    const dateReady = filterDate.getTime()
    const date2Ready = filterDate2.getTime()
    let operator

    switch (filterItem.type) {
      case 'on':
        operator = '='
        return `date([$${cellKey}$Date]) BETWEEN ${dateReady} AND ${date2Ready}`

        break
      case 'onOrAfter':
        operator = '>='
        break
      case 'after':
        operator = '>'
        break
      case 'onOrBefore':
        operator = '<='
        break
      case 'before':
        operator = '<'
        break
    }

    return `date([$${cellKey}$Date]) ${operator} ${dateReady}`
  }
}
